import { render, staticRenderFns } from "./verGrupo.vue?vue&type=template&id=0a68509c&scoped=true"
import script from "./verGrupo.vue?vue&type=script&lang=js"
export * from "./verGrupo.vue?vue&type=script&lang=js"
import style0 from "./verGrupo.vue?vue&type=style&index=0&id=0a68509c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a68509c",
  null
  
)

export default component.exports